<template>
    <div>
        <form class="form-horizontal" >

            <div class="panel panel-info">
                <!-- Default panel contents -->
                <div class="panel-heading">
                    <i class="fa fa-info-circle" aria-hidden="true"></i> DADOS BÁSICOS
                </div>
                <div class="panel-body">
                    <div class="form-group">

                        <div class="col-sm-5">
                            <label for="nome" :class="{'text-danger': !splitter.nome}" class="control-label">NOME DO MODELO DO SWITCH</label>
                            <input id="nome" type="text" v-model="splitter.nome" class="form-control" >
                        </div>

                        <div class="col-sm-4">
                            <label for="fabricante" :class="{'text-danger': !splitter.fabricante}" class="control-label">FABRICANTE DO MODELO DO SWITCH</label>
                            <input id="fabricante" type="text" v-model="splitter.fabricante" class="form-control" >
                        </div>

                        <div class="col-sm-3">
                            <label for="numero" :class="{'text-danger': !splitter.qtde_portas}" class="control-label">QTDE DE PORTAS</label>
                            <input id="numero" type="number" v-model.number="splitter.qtde_portas" class="form-control" >
                        </div>

                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-10">
                    <button type="button" v-if="user.level < 5" :disabled="! splitter.nome || !splitter.qtde_portas || !splitter.fabricante"
                            @click="save()"
                            class="btn btn-success">
                        <i class="fa fa-floppy-o" aria-hidden="true"></i> SALVAR MODELO DE SWITCH
                    </button>
                </div>
            </div>

        </form>
    </div>
</template>
<script>
/*global swal*/
import { ModeloSwitch } from "../../../class/index";

export default {
    data() {
        return {
            user: null,
            splitter: ModeloSwitch.create(),
            fibra: null
        };
    },
    computed: {
        _id() {
            return this.$route.params.id;
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        if (this._id) {
            this.loadPonto(this.$route.params.id);
        }
    },
    methods: {
        async loadPonto() {
            this.splitter = await ModeloSwitch.byID(this._id);
        },
        save() {
            // eslint-disable-next-line no-undef
            swal.queue([
                {
                    title: "SALVAR",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar o modelo?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            ModeloSwitch
                                .save(this.splitter)
                                .then(() => {
                                    resolve();
                                    this.$router.push({ path: "/modelos-switch" });
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
